import { type AnalyticsEvent } from '@shared/analytics';
const EXCLUDED = 'analytics_excluded_v1';
const VISITOR = 'analytics_visitor_v1';
const visit = crypto.randomUUID();
let visitor: string = visit;
let started = false;
let config: Promise<boolean> | undefined;
let configExpires = 0;
try {
  const stored = localStorage.getItem(VISITOR);
  visitor =
    stored && /^[0-9a-f-]{36}$/i.test(stored) ? stored : crypto.randomUUID();
  localStorage.setItem(VISITOR, visitor);
} catch {
  /* 浏览器存储不可用时只在本页使用随机编号。 */
}
export function isAnalyticsExcluded() {
  try {
    return localStorage.getItem(EXCLUDED) === '1';
  } catch {
    return false;
  }
}
export function setAnalyticsExcluded(value: boolean) {
  localStorage.setItem(EXCLUDED, value ? '1' : '0');
}
function channel() {
  const value = new URLSearchParams(location.search).get('c');
  return value
    ? /^[a-zA-Z0-9_-]{1,64}$/.test(value)
      ? value
      : 'invalid'
    : undefined;
}
function enabled(fresh = false) {
  if (fresh || !config || Date.now() > configExpires) {
    configExpires = Date.now() + 30000;
    config = fetch('/api/analytics/public-config', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => s?.collecting === true)
      .catch(() => false);
  }
  return config;
}
export function trackAnalytics(
  payload: Pick<AnalyticsEvent, 'kind'> & Partial<AnalyticsEvent>,
) {
  if (
    payload.kind === 'search' ||
    isAnalyticsExcluded() ||
    /bot|crawler|spider|preview/i.test(navigator.userAgent)
  )
    return;
  void enabled()
    .then((allowed) => {
      if (!allowed || isAnalyticsExcluded()) return;
      return fetch('/api/analytics/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          id: crypto.randomUUID(),
          visitor,
          visit,
          channel: channel(),
          ...payload,
        }),
      });
    })
    .catch(() => undefined);
}
export function startAnalytics() {
  if (!started) {
    started = true;
    trackAnalytics({ kind: 'pv' });
  }
}
export function trackLegacyView(action: () => Promise<unknown>) {
  if (isAnalyticsExcluded()) return;
  void enabled(true)
    .then((allowed) => {
      if (allowed && !isAnalyticsExcluded()) return action();
    })
    .catch(() => undefined);
}
